import { Country } from '../../../integrated-client/models/Country';

export type CountriesList = Array<Country>;

export class ResultsData {

  items: CountriesList
  showMore: boolean
  total?: number

  constructor() {
    this.items = [];
    this.showMore = false;
  }

}